import script from "./GlobalNotificationContent.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalNotificationContent.vue?vue&type=script&setup=true&lang=js"

import "./GlobalNotificationContent.vue?vue&type=style&index=0&id=0bec4f78&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bec4f78"]])

export default __exports__